import { useTranslations } from "next-intl";
import { Link } from "@/i18n/navigation";
import { cn } from "@/lib/cn";

export interface WordmarkProps {
  href?: string;
  size?: "sm" | "md" | "lg";
  className?: string;
}

// Heights for the horizontal PinkFlamingo.club lockup (aspect ~3.3:1).
// Applied inline so sizing never depends on which utilities Tailwind emits.
const heights = {
  sm: "1.5rem",
  md: "2rem",
  lg: "3rem",
} as const;

/** The real "PINK FLAMINGO .CLUB" horizontal lockup (white + pink, on dark). */
export function Wordmark({ href = "/", size = "md", className }: WordmarkProps) {
  const t = useTranslations("common");
  const img = (
    // eslint-disable-next-line @next/next/no-img-element -- static brand SVG, intrinsic aspect
    <img
      src="/brand/logo-horizontal.svg"
      alt="Pink Flamingo"
      className={cn("w-auto select-none", className)}
      style={{ height: heights[size] }}
      draggable={false}
    />
  );

  if (href) {
    return (
      <Link href={href} aria-label={t("wordmarkAriaLabel")} className="inline-flex">
        {img}
      </Link>
    );
  }
  return img;
}
